import React from "react"
import { FaBars } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./FailedPrintersTopbar.module.scss"

const FailedPrintersTopbar = props => {
  const { setOpenFailedPrintsSidebar } = props

  const i18n = useTranslation()[1]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <button
        id="failed-prints-hamburger-button"
        className={clsx(classes["button"], isLtr && classes["button-ltr"])}
        onClick={() => setOpenFailedPrintsSidebar(prev => !prev)}
      >
        <FaBars
          size={20}
          color="white"
        />
      </button>
    </div>
  )
}

export default FailedPrintersTopbar